import { ElMessage } from "element-plus";
import {computed, h, nextTick} from "vue";
import { useStore } from "vuex";
export default function useCommons() {
  const store = useStore();
  const showIcon = (item) => {
    if (item.settings) {
      const { place_password, place_whitelist_enable, whitelist_enable } =
        item.settings;
      if (place_password || place_whitelist_enable || whitelist_enable) {
        return true;
      }
    }
    return false;
  };
  const disabledMsg = () => {
    const userInfo = computed(() => store.getters.getUserInfo);
    if (userInfo.value) {
      const handleDate = {
        day: "天",
        hour: "小时",
        minute: "分钟",
        permanent: "永久禁言",
      };
      const { ban_status, ban_type, ban_day, ban_end_time, time_type, time } =
        userInfo.value;
      if (ban_status == 1) {
        ElMessage.warning({
          message: h(
            "div",
            { style: "color: #e6a23c;white-space: pre-wrap;" },
            [
              h("p", null, "你已被禁言!"),
              h(
                "p",
                null,
                `禁言原因：${ban_type}。${
                  time > 0
                    ? `\n解禁时间: ${time + handleDate[time_type]}后`
                    : `\n您已被永久禁言。`
                }`
              ),
            ]
          ),
        });
        return false;
      }
      return true;
    }
    return true;
  };
  const disabledTitleShow = (text, i = 75) => {
    return text?.length <= i;
  };


  /**
   * 根据样式判断元素是否要使用popover
   * 注意: 样式没有做太多处理, 只是为了回放视频底下的标题使用
   * @param elId
   */
  const disabledTitleShowByStyle = function(elId: string) {
    const el = document.getElementById(elId);
    // created时期没有dom元素生成, 先按照disabled true来处理
    if (el === null) return true

    el.style.overflow = 'auto';

    if (el.scrollHeight > el.clientHeight) {
      el.style.overflow = 'hidden'
    }
    return el.style.overflow !== 'hidden'
  }
  return {
    showIcon,
    disabledMsg,
    disabledTitleShow,
    disabledTitleShowByStyle,
  };
}
